<template>
  <div>
    <PrepareSignature :step="step" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import { ENVELOPE_TYPES, SIGNATURE_PROVIDER } from '@/project/signing-checklist/constants'
import PrepareSignature from '@/project/signing-checklist/prepare-signature/PrepareSignature.vue'

export default defineComponent({
  name: 'PrepareSignatureNda',
  components: { PrepareSignature },
  props: {
    ndaEnvelopeId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    step () {
      return {
        objectToPost: {
          envelope: {
            id: this.ndaEnvelopeId,
            envelopeType: ENVELOPE_TYPES.NDA,
            provider: SIGNATURE_PROVIDER.DOCUSIGN,
            signatureType: 'simple',
          },
        },
      }
    },
  },
})
</script>
